/* eslint-disable no-magic-numbers */

import Decimal from 'decimal.js';

import {
    toFixedOne,
} from '@gov.wa.lni/application.janitorial-workload-calculator/source/logic/helpers';

import {
    hoursPlanned,
    workPaceRatioActual,
    workPaceRatioPlanned,
} from '@gov.wa.lni/application.janitorial-workload-calculator/source/logic/calculations';

/**
 * See more in [readme.md](../../../readme.md)
 * @param assignment
 * @returns
 */
export const heartRateRecovery = (assignment:any) => {
    const value = new Decimal(intercept(assignment));
    const wpRatioPlanned = new Decimal(workPaceRatioPlanned(assignment));

    return value.plus(new Decimal(0.0107).times(wpRatioPlanned)).toString();
};

/**
 * See more in [readme.md](../../../readme.md)
 * @param assignment
 * @returns
 */
const intercept = (assignment:any) => {
    const hrrActual = new Decimal(assignment.trial.heartRateRecovery);
    const wpRatioActual = new Decimal(workPaceRatioActual(assignment));

    return hrrActual.minus(new Decimal(0.0107).times(wpRatioActual)).toString();
};

/**
 * See more in [readme.md](../../../readme.md)
 * @param assignment
 * @returns
 */
export const mawt = (assignment:any) => {
    const hrr = new Decimal(heartRateRecovery(assignment));
    const e = new Decimal(new Decimal(-4.81).times(hrr.div(100))).exp();

    // 26.12*e^(-4.81*L/100)
    return new Decimal(26.12).times(e).toString();
};

/**
 * See more in [readme.md](../../../readme.md)
 * @param assignment
 * @returns
 */
export const mawtRatio = (assignment:any) => {
    const result = new Decimal(mawt(assignment));
    const time = new Decimal(hoursPlanned(assignment));

    return toFixedOne(result.div(time).toString());
};

/**
 * See more in [readme.md](../../../readme.md)
 * @param jobPlan
 * @returns
 */
export const mawtRatioTotal = (jobPlan:any) => {
    let result = new Decimal(0);
    let time = new Decimal(0);
    jobPlan.forEach((assignment:any) => {
        result = result.plus(mawt(assignment));
        time = time.plus(hoursPlanned(assignment));
    });

    // Time average instead of mean of MAWT ratios
    return toFixedOne(result.div(time).toString());
};